<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/EventCategories/queries/eventCategories.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        id: { control: 'text', modifier: 'contains' },
        title: { control: 'text', modifier: 'contains' },
        slug: { control: 'text', modifier: 'contains' },
        isProtected: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        createdAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`events-categories.header-titles.${h.value}`)
                }}</span> -->
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value], 0) }}
              </div>
              <div v-else-if="h.text === 'Заголовок'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-category',
                    params: { id: item.id }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.value === 'slug'">
                <div>{{ mixCutSlug(item[h.value]) }}</div>
              </div>
              <div v-else-if="h.value === 'copySlug'">
                <a title="Копировать">
                  <v-btn icon @click="mixCopySlugHandler(item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-category',
                    params: { id: item.id }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteCategory(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import deleteEventCategory from '@/services/gql/types/EventCategory/mutations/deleteEventCategory.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'

export default {
  name: 'GridEventCategories',
  gridType: 'eventCategories',
  perPage,
  headersConfig,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  mixins: [gridDependentMixin],
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  data () {
    return {
      selectedCategories: [],
      queryState: null
    }
  },
  methods: {
    formatAmount,
    onTableDataChange () {
      this.selectedCategories = []
    },
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    async deleteCategory (catId) {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deleteCategory.$perform({
          deleteEventCategoryId: Number(catId)
        })
        this.$successMsg('Категория удалена')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении категории с ID ${catId}`
        )
      }
    }
  },
  async: {
    deleteCategory (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventCategory,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
